import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Vincler = () => {
  const navigate = useNavigate();
  const [vincler, setVincler] = useState([]);
  const [siparisler, setSiparisler] = useState([]);
  const [musteriler, setMusteriler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [durumFilter, setDurumFilter] = useState('');

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [vinclerRes, siparislerRes, musterilerRes] = await Promise.all([
        axios.get(`${API}/vincler`),
        axios.get(`${API}/siparisler`),
        axios.get(`${API}/musteriler`)
      ]);
      
      // Seri no'ya göre azalan sırala (en yeni üstte)
      const sortedVincler = vinclerRes.data.sort((a, b) => {
        const seriA = a.seri_no || '';
        const seriB = b.seri_no || '';
        return seriB.localeCompare(seriA, 'tr', { numeric: true });
      });
      
      setVincler(sortedVincler);
      setSiparisler(siparislerRes.data);
      setMusteriler(musterilerRes.data);
    } catch (error) {
      console.error('Veriler yüklenirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bu vinç kaydını silmek istediğinize emin misiniz?')) {
      try {
        await axios.delete(`${API}/vincler/${id}`);
        fetchData();
      } catch (error) {
        console.error('Vinç silinirken hata:', error);
        alert('Vinç silinemedi');
      }
    }
  };

  const getSiparisNo = (siparis_id) => {
    const siparis = siparisler.find(s => s.id === siparis_id);
    return siparis ? siparis.siparis_no : '-';
  };

  const getMusteriAdi = (siparis_id) => {
    const siparis = siparisler.find(s => s.id === siparis_id);
    if (!siparis) return '-';
    const musteri = musteriler.find(m => m.id === siparis.musteri_id);
    return musteri ? musteri.ad : '-';
  };

const getDurum = (siparis_id) => {
    const siparis = siparisler.find(s => s.id === siparis_id);
    return siparis ? siparis.durum : '-';
  };

  const printIsEmri = async (vinc_id) => {
    try {
      const response = await axios.get(`${API}/print/is-emri/${vinc_id}`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `is_emri_${vinc_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('İş emri oluşturulurken hata:', error);
      alert('İş emri oluşturulamadı');
    }
  };

// Arama ve durum filtresi
  const filteredVincler = vincler.filter(vinc => {
    const searchLower = searchTerm.toLowerCase();
    const musteriAdi = getMusteriAdi(vinc.siparis_id).toLowerCase();
    const siparisNo = getSiparisNo(vinc.siparis_id).toLowerCase();
    const durum = getDurum(vinc.siparis_id);
    
    const searchMatch = (
      vinc.seri_no?.toLowerCase().includes(searchLower) ||
      vinc.vinc_tipi?.toLowerCase().includes(searchLower) ||
      vinc.kapasite?.toLowerCase().includes(searchLower) ||
      musteriAdi.includes(searchLower) ||
      siparisNo.includes(searchLower)
    );
    
    const durumMatch = !durumFilter || durum === durumFilter;
    
    return searchMatch && durumMatch;
  });

  if (loading) {
    return <div className="loading" data-testid="loading">Yükleniyor...</div>;
  }

  return (
    <div data-testid="cranes-page">
      <div className="page-header">
        <h1 className="page-title">🏗️ Vinçler</h1>
        <p className="page-subtitle">Vinç kayıtlarını görüntüleyin ve yönetin</p>
      </div>

<div style={{ marginBottom: '24px', display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Seri no, müşteri adı, sipariş no veya vinç tipi ile ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="form-input"
          style={{ flex: 1, minWidth: '300px', maxWidth: '400px' }}
        />
        <select
          value={durumFilter}
          onChange={(e) => setDurumFilter(e.target.value)}
          className="form-select"
          style={{ minWidth: '150px' }}
        >
          <option value="">Tüm Durumlar</option>
          <option value="Beklemede">Beklemede</option>
          <option value="Üretimde">Üretimde</option>
          <option value="Boyamada">Boyamada</option>
          <option value="Montajda">Montajda</option>
          <option value="Teslim Edildi">Teslim Edildi</option>
        </select>
        <button className="btn btn-primary" onClick={() => navigate('/vincler/yeni')} data-testid="add-crane-btn">
          <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Yeni Vinç
        </button>
      </div>

      {filteredVincler.length === 0 ? (
        <div className="empty-state" data-testid="empty-state">
          {searchTerm ? (
            <>
              <h3>Arama sonucu bulunamadı</h3>
              <p>"{searchTerm}" ile eşleşen vinç kaydı yok</p>
            </>
          ) : (
            <>
              <h3>Henüz vinç kaydı yok</h3>
              <p>Yeni vinç eklemek için yukarıdaki butona tıklayın</p>
            </>
          )}
        </div>
      ) : (
        <div className="card">
          <div style={{ marginBottom: '12px', color: '#666', fontSize: '14px' }}>
            {searchTerm && `${filteredVincler.length} sonuç bulundu`}
          </div>
          <table className="table" data-testid="cranes-table">
            <thead>
              <tr>
                <th>Seri No</th>
                <th>Müşteri</th>
                <th>Sipariş No</th>
                <th>Vinç Tipi</th>
                <th>Kapasite</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {filteredVincler.map(vinc => (
                <tr key={vinc.id} data-testid={`crane-row-${vinc.id}`}>
                  <td style={{ fontWeight: 600 }}>{vinc.seri_no}</td>
                  <td>{getMusteriAdi(vinc.siparis_id)}</td>
                  <td>{getSiparisNo(vinc.siparis_id)}</td>
                  <td>{vinc.vinc_tipi}</td>
                  <td>{vinc.kapasite}</td>
                  <td>
                    {(() => {
                      const durum = getDurum(vinc.siparis_id);
                      const renkler = {
                        'Beklemede': { bg: '#fef3c7', color: '#92400e' },
                        'Üretimde': { bg: '#dbeafe', color: '#1e40af' },
                        'Boyamada': { bg: '#ede9fe', color: '#5b21b6' },
                        'Montajda': { bg: '#cffafe', color: '#0e7490' },
                        'Teslim Edildi': { bg: '#d1fae5', color: '#065f46' }
                      };
                      const renk = renkler[durum] || { bg: '#f3f4f6', color: '#374151' };
                      return (
                        <span style={{
                          padding: '4px 12px',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: 500,
                          background: renk.bg,
                          color: renk.color
                        }}>
                          {durum}
                        </span>
                      );
                    })()}
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="icon-btn" onClick={() => printIsEmri(vinc.id)} title="İş Emri Yazdır" data-testid={`print-work-order-${vinc.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                        </svg>
                      </button>
                      <button className="icon-btn" onClick={() => navigate(`/vincler/${vinc.id}`)} data-testid={`edit-crane-${vinc.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>
                      <button className="icon-btn danger" onClick={() => handleDelete(vinc.id)} data-testid={`delete-crane-${vinc.id}`}>
                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Vincler;